export default __webpack_public_path__ + "static/media/marauders-map-v4-01-00.d0223fbc.jpg";